/**
 * Verifica se um segmento de URL é um ID (numérico ou UUID).
 */
export function isIdSegment(segment: string): boolean {
  const numericId = /^\d+$/;
  const uuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return numericId.test(segment) || uuid.test(segment);
}

/**
 * Retorna a rota "um nível acima" para o botão Voltar.
 * Usado no Breadcrumb e na página 404 (redirecionar quando a rota não existe).
 */
export function getRotaVoltar(pathname: string): string {
  const pathnames = pathname.split("/").filter((x) => x);

  if (pathnames.length <= 1) return "/";

  const ultimoSegmento = pathnames[pathnames.length - 1];
  const penultimoSegmento = pathnames[pathnames.length - 2];

  // Caso: /defensor/editar/uuid ou /editar/uuid -> volta para /defensor ou /
  if (penultimoSegmento === "editar" && isIdSegment(ultimoSegmento)) {
    const rota = pathnames.slice(0, -2);
    return rota.length > 0 ? `/${rota.join("/")}` : "/";
  }

  // Caso: /defensor/editar ou /editar -> volta para /defensor ou /
  if (ultimoSegmento === "editar" || ultimoSegmento === "criar") {
    const rota = pathnames.slice(0, -1);
    return rota.length > 0 ? `/${rota.join("/")}` : "/";
  }

  // Caso: último segmento é ID (ex.: /folha-frequencia/uuid) -> volta para o índice (um nível acima)
  if (isIdSegment(ultimoSegmento)) {
    return `/${pathnames.slice(0, -1).join("/")}`;
  }

  // Caso padrão: volta para o nível anterior
  return `/${pathnames.slice(0, -1).join("/")}`;
}
